import { DropDown, useWorkplaceState, ValidatedDropDownList } from '@finbeat/react-toolkit';
import { AxiosError } from 'axios';
import useApi from 'hooks/useApi';
import { t } from 'i18next';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import { UserItem } from 'models/api/users';
import { Key, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getSelectList } from 'axios/dictionaryApi';

type BrandCodeTabProps = {
    disabled: boolean;
    toggle: (tab?: Key) => void;
};

const BrandCodeTab = ({ disabled, toggle }: BrandCodeTabProps) => {
    const api = useApi();
    const { handleError } = useWorkplaceState();
    const { data: brandCodeResponse, isFetching: brandCodesLoading } = useQuery(
        'BrandCodes',
        () => getSelectList(api, ['BrandCode']),
        {
            onError: (e: AxiosError<AxiosErrorResponse>) => handleError(e.response?.data),
        }
    );

    const brandCodes = useMemo<DropDown[]>(() => {
        return brandCodeResponse?.['BrandCode'] ?? [];
    }, [brandCodeResponse]);

    return (
        <ValidatedDropDownList<UserItem>
            name="brandCode"
            label={t('BackOfficeBrandCode')}
            disabled={disabled}
            items={brandCodes || []}
            isLoading={brandCodesLoading}
        />
    );
};

export default BrandCodeTab;
